import api, { apiSetup } from '../api';

apiSetup();

export class TermsService {
  BASE_URL = '/terms';

  get() {
    return api.get(this.BASE_URL);
  }
}
